import ICONS from "../../../assets/Icons";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

/**
 * CommonCardDashboard
 *
 * Rules:
 * 1. Loader → visually disabled, no click
 * 2. Service NOT found ("N/A")
 *    - visually disabled
 *    - click ENABLED
 *    - navigates to Feature Not Assigned
 * 3. Service found
 *    - 00 or >0 → enabled
 * 4. isDisabled === true → visually disabled + no click
 */

const CommonCardDashboard = ({
  label,
  count,
  color,
  onClick,
  onServiceUnavailable,
  loader = false,
}) => {
  const isServiceUnavailable = count === "N/A";

  const numericCount =
    count === "N/A"
      ? null
      : Number(count ?? GlobalConfiguration.lengthCheckZero);

  const isZeroCount =
    numericCount === GlobalConfiguration.lengthCheckZero ||
    numericCount === null;

  const isVisuallyDisabled = loader || isServiceUnavailable || isZeroCount;

  const handleClick = () => {
    if (loader) return;

    if (isServiceUnavailable) {
      onServiceUnavailable?.();
      return;
    }

    if (isZeroCount) return;

    onClick?.();
  };

  const formatCount = (value) => {
    if (value === "N/A") return "N/A";

    if (value === null || value === undefined) return "00";

    const num = Number(value);

    if (Number.isNaN(num)) return value;

    if (num === GlobalConfiguration.lengthCheckZero) return "00";

    return num.toLocaleString("en-IN");
  };

  return (
    <div
      role="button"
      onClick={handleClick}
      className={`
        flex flex-col items-center justify-center flex-1 gap-gap-xs p-padding-md Qsmd:py-padding-lg relative z-z-index-base transition-all duration-animation-fast-s
        ${
          isVisuallyDisabled
            ? "opacity-light-opacity cursor-not-allowed"
            : "cursor-pointer global-hover-white"
        }
      `}
    >
      {loader ? (
        <img
          className="w-icon-lg h-icon-lg"
          src={ICONS?.LOADER_GIF}
          alt="Loading..."
        />
      ) : (
        <p className="text-font-xl font-semibold" style={{ color }}>
          {formatCount(count)}
        </p>
      )}

      <p className="text-text-primary text-font-sm whitespace-nowrap">
        {label}
      </p>
    </div>
  );
};

export default CommonCardDashboard;
